module.exports = __webpack_public_path__ + "static/media/books-mob.ed4153d3.jpg";